"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrackOnView = void 0;
const react_1 = require("react");
/**
 * Hook that helps you to track event that relies on some data to be ready. It makes sure that it is sent only once. Useful for tracking page viewed {@link https://github.com/cultureamp/node-packages/tree/master/packages/amplitude#track-page-viewed-event} or use alongside with `useFragmentTracker` {@link https://github.com/cultureamp/node-packages/tree/master/packages/amplitude#track-events-with-fragments-of-data-not-colocated-in-the-same-component}
 * @param event - A callback that calls the Avo function that you want to track
 * @param {boolean} isReady - Determines when it is ready to send the event (defaults to true if not provided). The event is sent in the first moment when isReady is true
 */
const useTrackOnView = (event, isReady = true) => {
    const wasReported = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (!wasReported.current && isReady) {
            wasReported.current = true;
            event();
        }
    }, [event, isReady]);
};
exports.useTrackOnView = useTrackOnView;
//# sourceMappingURL=hooks.js.map